import React from 'react';
import {
  Box,
  IconButton,
  Typography,
  Tooltip
} from '@mui/material';
import { Clear } from '@mui/icons-material';
import { PopoverListButtons } from '../../../Utils/styledComps';

const CustomHomePopoverContent = ({ home, handlePopoverClose }) => {
  return (
    <Box sx={{ height: 500, width: 320 }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 1.25,
        py: 1
      }}>
        <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
          Home
        </Typography>
        <Tooltip title="Close menu" arrow>
          <IconButton
            edge="end"
            onClick={handlePopoverClose}
            aria-label="Close home menu"
            sx={{ borderRadius: 1 }}
          >
            <Clear />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{
        display: 'flex',
        gap: 1,
        m: 1.25,
        flexWrap: 'wrap'
      }}>
        {home.map((house, index) => (
          <Tooltip key={index} title={house.label} arrow placement="bottom">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: 55,
                m: 0.625,
                cursor: 'pointer',
                color: 'action.hover',
                transition: (theme) => theme.transitions.create(['transform'], {
                  duration: theme.transitions.duration.shorter,
                }),
                '&:hover': {
                  transform: 'translateY(-2px)',
                },
              }}
              onClick={house.onClick}
            >
              <PopoverListButtons sx={{ p: 2 }} aria-label={house.label}>
                {house.icon}
              </PopoverListButtons>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  textAlign: 'center',
                  fontSize: 11,
                  color: 'text.primary'
                }}
              >
                {house.label}
              </Typography>
            </Box>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default CustomHomePopoverContent;
